
import { BASE_URL } from "../config";

export const addUserRole = async (user) => {
  try {
    const response = await fetch(`${BASE_URL}/User/add-role`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(user)
    });

    const result = await response.json(); 
    if (!response.ok) {
      throw new Error(result.message || "Failed to add employee role");
    }

    // return await response.json(); 
    // const result = await response.text();
    console.log("Success:", result);
    return result;

  } catch (error) {
    console.error("Error adding employee role:", error);
    throw error;
  }
};

export const getAllRoles = async () => {
  try {
    const response = await fetch(`${BASE_URL}/User/roles`);
    if (!response.ok) {
      throw new Error("Failed to fetch roles");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching roles:", error);
    throw error;
  }
};


export const getAllUserRoles = async () => {
  try {
    const response = await fetch(`${BASE_URL}/User/userroles`);
    if (!response.ok) {
      throw new Error("Failed to fetch roles");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching roles:", error);
    throw error;
  }
};
